import EDC from '../../../shared/globals';

EDC.Animations.PigMistake = function (scene, pigSprite) {
  this.scene = scene;
  this.pig = pigSprite;
};

EDC.Animations.PigMistake.prototype.play = function () {
  this.scene.tweens.add({
    targets: this.pig,
    angle: this.pig.angle + 15,
    duration: 50,
    ease: 'Sine.easeInOut',
    repeat: 3,
    yoyo: true,
  });
};

export default EDC.Animations.PigMistake;
